<template>
  <input
    :id="field.handle"
    :type="type"
    :name="name"
    class="
      form-input peer px-0 h-12 w-full bg-transparent border-0 border-b border-purple-dark/25 transition duration-300
      focus:ring-0 focus-visible:ring-0 focus:outline-0 focus-visible:outline-0 focus:border-purple-dark
      group-hover:border-purple-dark
      md:text-lg
    "
    @change="emits('update', $event)"
    :required="isRequired"
    placeholder=""
    autocomplete="off"
  >

  <label
    :for="field.handle"
    class="
      -translate-y-15 text-purple-dark/50 leading-none transition duration-300 origin-left will-change-transform
      group-hover:text-purple-dark group-hover:-translate-y-[4.25rem] group-hover:scale-75
      peer-focus:text-purple-dark peer-focus:-translate-y-[4.25rem] peer-focus:scale-75
      peer-[:not(:placeholder-shown)]:text-purple-dark peer-[:not(:placeholder-shown)]:-translate-y-[4.25rem] peer-[:not(:placeholder-shown)]:scale-75
      md:text-lg
    "
  >
    {{ label }}<span v-if="isRequired">*</span>
  </label>
</template>

<script setup lang="ts">
import type { Field } from '~/statamic/types/form';

const props = defineProps<{
  name: string;
  field: Field;
  rules: string[];
  label?: string;
  hiddenFields?: string[];
}>();

const emits = defineEmits([
  'update',
]);

const isRequired = props.rules.includes('required');

const type = computed(() => {
  if (props.hiddenFields && props.hiddenFields.includes(props.field.handle)) {
    return 'hidden';
  }

  return props.field.config.input_type;
});
</script>
